import React from "react"
import { useHistory } from "react-router"
import BreadCrumb from "components/BreadCrumb"
import { EmployeeSettingsRoutes } from "app/routes/types"
import routes from "app/routes"
import { HeaderWrapper, StyledTab, StyledTabs, StyledAppBar } from "./style"
import Config from "./config"

const PersonalAbsencesTabs = ({ id: tabId }: { id: EmployeeSettingsRoutes }) => {
  const history = useHistory()
  const handleClick = (newTabId: EmployeeSettingsRoutes) => {
    history.push(`/${newTabId}`)
  }
  return (
    <StyledAppBar color="primary" position="sticky" elevation={0}>
      <BreadCrumb routes={routes} />
      <HeaderWrapper>
        <StyledTabs value={tabId} TabIndicatorProps={{ className: "indicator" }}>
          {Config.map(({ id, label }) => (
            <StyledTab key={id} label={label} value={id} selected={tabId === id} onClick={() => handleClick(id)} />
          ))}
        </StyledTabs>
      </HeaderWrapper>
    </StyledAppBar>
  )
}

export default PersonalAbsencesTabs
